import type { NextPage } from "next";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pricing from "src/components/pricing";
import { snackAdded } from "src/slices/system";
import { selectUserRole } from "src/slices/system/selectors";
import { getCurrentUser } from "src/slices/system/thunks";
import { AuthGuard } from "../../components/authentication/auth-guard";
import { DashboardLayout } from "../../components/dashboard/dashboard-layout";
import { gtm } from "../../lib/gtm";
export interface CustomWindow extends Window {
  FPROM: any;
}

declare let window: CustomWindow;

const PricingPage: NextPage = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const userRole = useSelector(selectUserRole);

  useEffect(() => {
    gtm.push({ event: "page_view" });
    const query = new URLSearchParams(window.location.search);
    dispatch(getCurrentUser());
    if (query.get("success")) {
      isSuccessful();
    }
    if (query.get("canceled")) {
      dispatch(
        snackAdded({
          type: "error",
          message:
            "Order canceled - continue to shop around and checkout when you’re ready.",
        })
      );
    }
  }, []);

  const isSuccessful = async () => {
    const currentUserReq: any = await dispatch(getCurrentUser());
    const userEmail = currentUserReq?.payload?.email;

    window.FPROM?.fpr("referral", { email: userEmail });
    //wait for 2 seconds to allow the referral to be sent
    setTimeout(() => {
      window.FPROM?.fpr("conversion", { email: userEmail });
    }, 2000);

    router.push("/dashboard");
    dispatch(
      snackAdded({
        type: "success",
        message: "Order placed! You will receive an email confirmation.",
      })
    );
  };

  useEffect(() => {

    if (userRole !== "owner" && userRole !== "full") {
      router.push("/dashboard");
    }
  }, [userRole]);

  return (
    <>
      <Pricing />
    </>
  );
};

PricingPage.getLayout = (page) => (
  <AuthGuard>
    <DashboardLayout>{page}</DashboardLayout>
  </AuthGuard>
);

export default PricingPage;
